import { useEffect, useState } from "react";
import { api, ApiError } from "../api";
import type { DraftFile } from "../types";
import type { ComponentProps } from "./index";

/**
 * Renders `{ name, title? }`: a draft's files, each folded under its path. The builder calls this
 * once a draft is written, so the person can open SPEC.md or SYSTEM.md without the whole draft
 * scrolling through the conversation. Fetched from the drafts route, not the session workspace:
 * the draft is the builder's, and a session shared with the other person still shows it.
 */
export function Draft({ args }: ComponentProps): React.ReactNode {
	const name = typeof args.name === "string" ? args.name : undefined;
	const title = typeof args.title === "string" ? args.title : undefined;
	const [files, setFiles] = useState<DraftFile[] | null>(null);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (!name) return;
		let cancelled = false;
		api
			.draftFiles(name)
			.then((r) => !cancelled && setFiles(r.files))
			.catch((e) => !cancelled && setError(e instanceof ApiError ? e.message : String(e)));
		return () => {
			cancelled = true;
		};
	}, [name]);

	if (!name) return <div className="component error">show_draft 缺少 name 参数，收到的参数：{JSON.stringify(args)}</div>;
	return (
		<div className="component draft-component">
			<div className="document-title">{title ?? `草稿 ${name}`}</div>
			{error && <p className="error">{error}</p>}
			{files === null && !error && <p className="hint">加载中…</p>}
			{files?.length === 0 && <p className="hint">drafts/{name}/ 为空</p>}
			{files?.map((f) => (
				<details key={f.path} className="draft-file">
					<summary>
						<code>{f.path}</code>
					</summary>
					<pre>{f.content}</pre>
				</details>
			))}
		</div>
	);
}
